import MuiCheckbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import type { ReactNode } from 'react';
import { useId } from 'react';

import { useColors } from '../ThemeProvider';

interface Props {
  label: string | ReactNode;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function Checkbox({
  label,
  checked = false,
  disabled = false,
  indeterminate = false,
  onChange,
}: Props) {
  const generatedId = useId();
  const labelId = `${generatedId}-label`;
  const { primary, textDisabled } = useColors();

  return (
    <FormControl
      sx={{
        ml: '-0.7rem',
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <MuiCheckbox
        id={generatedId}
        name={generatedId}
        disabled={disabled}
        checked={checked}
        indeterminate={indeterminate}
        onChange={onChange}
        sx={{
          color: primary,
          '&.Mui-disabled': { color: textDisabled },
        }}
      />

      <FormLabel
        htmlFor={generatedId}
        id={labelId}
        sx={{ color: disabled ? textDisabled : primary }}
      >
        {label}
      </FormLabel>
    </FormControl>
  );
}
